import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import Goals from './pages/Goals';
import Contact from './pages/Contact';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Fallback component for unmatched routes
const NotFound = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center bg-paper px-6 text-center">
    <h2 className="section-title mb-6">Route Lost in the Soil</h2>
    <p className="serif italic text-xl text-[#A65D3F] mb-12">"Not all who wander are lost, but this path doesn't lead anywhere yet."</p>
    <Navigate to="/" replace />
  </div>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col selection:bg-[#C9A227] selection:text-[#1A1A1A]">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/goals" element={<Goals />} />
            <Route path="/contact" element={<Contact />} />
            {/* Catch-all route to redirect back home or to a 404 page */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;